import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { AreaCascader as LocalAreaCascader } from '../../components/AreaCascader'

export const AreaCascader = connect(
  LocalAreaCascader,
  mapReadPretty(LocalAreaCascader, {
    disabled: true
  })
)
